import { IRootReducer } from '../../types/reducerTypes'

export const selectDrop = ({ drop }: IRootReducer) => drop.drop
